/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid400,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid401,
  GetApiV1ExamCorrectionDashboardClassroomdisciplineid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboardClassroomdisciplineid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCorrectionDashboardClassroomdisciplineid } from "../../clients/examCorrectionDashboardController/getApiV1ExamCorrectionDashboardClassroomdisciplineid.ts";

export const getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey = (
  classroomDisciplineId: GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams["classroomDisciplineId"],
  params?: GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/correction-dashboard/:classroomDisciplineId",
      params: { classroomDisciplineId: classroomDisciplineId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey =
  ReturnType<
    typeof getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey
  >;

export function getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryOptions(
  classroomDisciplineId: GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams["classroomDisciplineId"],
  params?: GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey(
    classroomDisciplineId,
    params,
  );
  return queryOptions<
    GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid400
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid401
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid500
    >,
    GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
    typeof queryKey
  >({
    enabled: !!classroomDisciplineId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCorrectionDashboardClassroomdisciplineid(
        classroomDisciplineId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os detalhes do painel de correções para uma disciplina específica da sala de aula. **(Requer Authorization para autenticação)**
 * @summary Detalhe do painel de correção (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-dashboard/:classroomDisciplineId}
 */
export function useGetApiV1ExamCorrectionDashboardClassroomdisciplineid<
  TData = GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
  TQueryData =
    GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey,
>(
  classroomDisciplineId: GetApiV1ExamCorrectionDashboardClassroomdisciplineidPathParams["classroomDisciplineId"],
  params?: GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCorrectionDashboardClassroomdisciplineidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCorrectionDashboardClassroomdisciplineid400
          | GetApiV1ExamCorrectionDashboardClassroomdisciplineid401
          | GetApiV1ExamCorrectionDashboardClassroomdisciplineid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryKey(
      classroomDisciplineId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1ExamCorrectionDashboardClassroomdisciplineidQueryOptions(
        classroomDisciplineId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid400
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid401
      | GetApiV1ExamCorrectionDashboardClassroomdisciplineid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
